import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import IconButton from 'components/common/IconButton';
import { errorNotification, handleApiError } from 'utils';
import { uploadEpstMedia } from 'api/files/files';

function UploadMedia({ handleLoad, fileType, setLoading }) {
	const token = useSelector(state => state.authentication.user?.token);
	const [file, setFile] = useState(null);
	const [previewUrl, setPreviewUrl] = useState(null);
	const fileMedioRef = useRef(null);

	useEffect(() => {
		return () => {
			if (previewUrl) URL.revokeObjectURL(previewUrl);
		};
	}, [previewUrl]);

	const fetchUploadMedia = async (form, newFileName) => {
		try {
			setLoading(true);
			const { data } = await uploadEpstMedia(fileType, form, token);
			if (data.status === 200) {
				const fullPath = data.file_path;
				const fileName = fullPath.split('/').pop();
				handleLoad(fileName);
				handleFileReset();
			} else {
				errorNotification("No es posible subir el archivo.");
			}
		} catch (error) {
			handleApiError(error);
		} finally {
			setLoading(false);
		}
	};

	const handleFileChange = (event) => {
		const selectedFile = event.target.files[0];
		if (!selectedFile) return;

		const fileName = selectedFile.name.toLowerCase();
		const isValidImage = fileType === "images" && /\.(jpg|jpeg|png|gif|webp)$/i.test(fileName);
		const isValidAudio = fileType === "audios" && /\.(mp3|wav|ogg|aac)$/i.test(fileName);

		if (isValidImage || isValidAudio) {
			setFile(selectedFile);
			const tempUrl = URL.createObjectURL(selectedFile);
			setPreviewUrl(tempUrl);
			handleLoad(tempUrl); // mostrar preview local
		} else {
			errorNotification(`Formato no válido. Selecciona un archivo ${fileType === "images" ? "de imagen" : "de audio"}.`);
			setFile(null);
			setPreviewUrl(null);
		}
	};

	const handleUpload = async () => {
		if (!file) {
			errorNotification("Es necesario seleccionar un archivo.");
			return;
		}
		const form = new FormData();
		form.append('uploaded_file', file, file.name);
		form.append('file_type', fileType);
		await fetchUploadMedia(form, file.name);
	};

	const handleFileReset = () => {
		setFile(null);
		setPreviewUrl(null);
		fileMedioRef.current.value = '';
	};

	const handleFileInputClick = () => {
		fileMedioRef.current.click();
	};

	return (
		<>
			<input
				type="file"
				className="form-control"
				id="submitFile"
				onChange={handleFileChange}
				accept={fileType === "images" ? "image/*" : "audio/*"}
				style={{ display: 'none' }}
				ref={fileMedioRef}
			/>
			<IconButton
				variant="falcon-default"
				size="sm"
				icon={file ? "file-upload" : "file-import"}
				transform="shrink-3"
				className="me-2"
				iconAlign="middle"
				onClick={file ? handleUpload : handleFileInputClick}
			>
				<span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
					{file ? 'Actualizar' : 'Cambiar'}
				</span>
			</IconButton>
			{file && (
				<>
					<span className="text-success me-2">{file.name}</span>
					<IconButton
						variant="falcon-default"
						size="sm"
						icon={"times"}
						transform="shrink-3"
						className="me-2"
						iconAlign="middle"
						onClick={handleFileReset}
					/>
				</>
			)}
		</>
	);
}

export default UploadMedia;